<template>
    <div class="right-menu">
      <rightbox class="right-top">
        <div class="box-item" :class="{'active':curMenu=='home'}"  @click="menuClick('home')">
        <!-- <div class="item-ico iconfont2 icon-ditu"></div> -->
        <div class="item-ico ico ico-draw"></div>
        <div class="item-txt" style="transform: scale(0.85);">地图模式</div>
      </div>
      <div class="box-item"  :class="{'active':curMenu=='ar'}" @click="menuClick('ar')">
        <!-- <div class="item-ico iconfont2 icon-AR"></div> -->
        <div class="item-ico ico ico-video"></div>
        <div class="item-txt">AR模式</div>
      </div>
      <div class="box-item"  :class="{'active':curMenu=='vr'}" @click="menuClick('vr')">
        <!-- <div class="item-ico iconfont2 icon-VR"></div> -->
        <div class="item-ico ico ico-vr"></div>
        <div class="item-txt">VR模式</div>
      </div>
      </rightbox>

      <rightbox class="right-aim"  @click.native="menuClick('aim')" v-if="curMenu =='home'">
        <div class="box-item">
          <div class="item-ico ico ico-aim"></div>
          <div class="item-txt">定位</div>
        </div>
      </rightbox>
      <!-- <rightbox class="right-scan"  @click.native="menuClick('scan')" v-if="isscan">
        <div class="box-item">
          <div class="item-ico ico ico-scan"></div>
          <div class="item-txt">核销</div>
        </div>
      </rightbox> -->
      <!-- <div class="bottom-rr"> -->
      <div>
        
        <rightbox class="right-link" v-if="curMenu =='home' && curInfo">
          <!-- <div class="box-item"   @click="menuClick('feature')">
            <div class="item-ico ico ico-shipin"></div>
            <div class="item-txt">视频</div>
          </div> -->
          <!-- <div class="box-item" @click="menuClick('glue')">
            <div class="item-ico ico ico-gonglue"></div>
            <div class="item-txt">攻略</div>
          </div> -->
          <!-- <div class="box-item" @click="menuClick('clock')" v-if="config.clock">
            <div class="item-ico iconfont2 icon-zuji"></div>
            <div class="item-txt">足迹</div>
          </div> -->

          <!-- <div class="box-item" :class="{'show':barrage}" @click="menuClick('barrage')">
            <div class="item-ico ico ico-dm " :class="{'active':barrage}"></div>
            <div class="item-txt">弹幕</div>
          </div> -->
          <!-- @click="menuClick('audio')" -->
          <div class="box-item audio-item" @click="changeAudioState"  v-if="curInfo">
            <div class="item-ico music-play" v-if="audioPlay">
              <span class="line line1" style="animation-delay: 0.1s;"></span>
              <span class="line line2" style="animation-delay: 0.2s;"></span>
              <span class="line line3" style="animation-delay: 0.3s;"></span>
              <span class="line line4" style="animation-delay: 0.4s;"></span>
              <span class="line line5" style="animation-delay: 0.5s;"></span>
            </div>
            <div class="item-ico ico ico-audio" v-else></div>
            <p class="item-txt" :class="{'playing':audioPlay}" :data-text="curInfo.name">{{ curInfo.name }}</p>
          </div>
          <!-- <div class="box-item" @click="menuClick('concat')">
            <div class="item-ico ico ico-tel"></div>
            <div class="item-txt">客服</div>
          </div>-->
          <!-- <div class="box-item" @click="menuClick('advice')">
            <div class="item-ico iconfont2 icon-fankui"></div>
            <div class="item-txt">反馈</div>
          </div> -->
        </rightbox>
        <rightbox>
          <div class="box-item" @click="menuClick('back')">
            <div class="item-ico iconfont icon-reply-line"></div>
            <div class="item-txt">返回</div>
          </div>
        </rightbox>
      </div>

    </div>
</template>
<script>
import config from '@/config';
import rightbox from './rightbox.vue'
import { mapState,mapGetters,mapMutations } from 'vuex';
export default {
  components: { rightbox },
  props:{
    curMenu:{
    type:String,
    default:'home'
  }},
  data(){
    return{
      config,
      isscan: false,
    }
  },
  computed:{
     ...mapGetters("audio", {
      curInfo: "getCurAudio",
    }),
     ...mapState("audio",{
        audioPlay:"playState",
      })
  },
  mounted(){
    this.getUserVerify();
  },
  methods: {
    ...mapMutations(['audio/updatePlayState']),
    menuClick(type){
      this.$emit('change',{
        event:type
      })
    },
    changeAudioState(){
      if(this.audioPlay){
        this['audio/updatePlayState'](false)
      }else{
        this['audio/updatePlayState'](true)
      }
    },
    // 商户权限
    async getUserVerify(){
      let data = await this.$api.userApi.getUserVerify();
      if(data&&data.data){
        this.isscan = true;
      }else {
        this.isscan = false;
      }
    },
  },
}
</script>
